import { cn } from '@/lib/utils'

/**
 * LOCKED — confidence as % + bar beside the rule that produced it (meridian
 * borrow). Bar is mint (a proposal's self-assessment is a proposal). Figure is
 * tabular sans.
 */
export function ConfidenceBar({ pct, className }: { pct: number | null; className?: string }) {
  if (pct === null) {
    return <span className={cn('text-xs text-muted-foreground', className)}>—</span>
  }
  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <span className="v-figure text-sm font-semibold tabular-nums">{pct}%</span>
      <span className="h-1.5 w-14 overflow-hidden rounded-full bg-muted" role="presentation">
        <span className="block h-full rounded-full bg-mint" style={{ width: `${pct}%` }} />
      </span>
    </span>
  )
}
